import { render, staticRenderFns } from "./relationList.vue?vue&type=template&id=5a44382e&scoped=true&"
import script from "./relationList.vue?vue&type=script&lang=js&"
export * from "./relationList.vue?vue&type=script&lang=js&"
import style0 from "./relationList.vue?vue&type=style&index=0&id=5a44382e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44382e",
  null
  
)

export default component.exports